import { type Accessor, createSignal, startTransition } from "solid-js";
import { isServer } from "solid-js/web";

/**
 * Viewport width in px below which a surface switches to its mobile layout. It must track
 * Tailwind's `md` breakpoint (`--breakpoint-md` in `@storytell/tailwind-theme`), so a JS switch
 * flips at the same width as the `md:` classes beside it.
 */
export const MOBILE_BREAKPOINT_PX = 768;

// One media-query listener for the whole app: a component per sent message reads this, and a
// width read per instance forced a layout on every mount and resize.
let below: Accessor<boolean> | undefined;

/** True while the viewport is narrower than {@link MOBILE_BREAKPOINT_PX}. */
export function useWindowWidth(): Accessor<boolean> {
  if (isServer) return () => false;

  if (!below) {
    const query = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT_PX - 0.02}px)`);
    const [matches, setMatches] = createSignal(query.matches);
    query.addEventListener("change", (event) => void startTransition(() => setMatches(event.matches)));
    below = matches;
  }
  return below;
}
